import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import { accountActions, passwordActions, popupActions } from "../_actions";
import AcccountSelector from "../components/AccountSelector";
import Loading from "../components/Loading";
import NewPassword from "../components/NewPassword";
import AlertSettings from "../components/AlertSettings";
import SuccessMessage from "../components/SuccessMessage";
import moment from "moment";
import EmailReportSettings from "../components/EmailReportSettings";
import PopupWrapper from "../components/PopupWrapper";
import { withCookies } from "react-cookie";
import DiscList from "../components/DiscList";
import Spacer from "../components/Spacer";
import AccountBackButton from "../components/AccountBackButton";

class AccountHome extends Component {
  render() {
    const { account } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          {localStorage.getItem("house_id") !== 'undefined' && (
            <DiscList
              title={"HomeView"}
              size={"small"}
              icon={"/icons/home.svg"}
              subTitle={"Manage settings for HomeView"}
              href="/account/homeview/"
            />
          )}
          <DiscList
            title={"InfoCare"}
            size={"small"}
            icon={"/icons/infocare.svg"}
            subTitle={"Manage settings for InfoCare"}
            href="/account/infocare/"
          />
          <DiscList
            title={"Do Not Disturb"}
            size={"small"}
            icon={"/icons/weather-night.svg"}
            subTitle={"Silence all notifications"}
            href="/account/do-not-disturb/"
          />
          <DiscList
            title={"Password"}
            size={"small"}
            icon={"/icons/lock-outline.svg"}
            subTitle={"Change your current password"}
            href="/account/password/"
          />
          <Spacer />
          <a href="/login" className={css(styles.buttonRed)}>
            Sign Out
          </a>
        </main>
      </div>
    );
  }
}

export default AccountHome;
